import {
  Col,
  Row,
  Select,
  DatePicker,

  Card,

  Space,
} from 'antd';
import {useState, useEffect} from 'react';
import {
  ToolOutlined,
  FileDoneOutlined,
  InboxOutlined,
  FileTextOutlined,
  CalendarOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Graph1 from './Graph1';
import {useDispatch, useSelector} from 'react-redux';
import {fetchDashboardData} from '../../slices/dashboard';

dayjs.extend(customParseFormat);
const {RangePicker} = DatePicker;
const {MonthPicker} = DatePicker;

export default function Dashboard() {
  const [dateRange, setDateRange] = useState([
    dayjs().startOf('month'),
    dayjs().endOf('month'),
  ]);
  const [selectedYear, setSelectedYear] = useState(dayjs().year().toString());
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month());
  const [selectedGraphMonth, setSelectedGraphMonth] = useState(dayjs().month());
  const [selectedGraphYear, setSelectedGraphYear] = useState(dayjs().year());

  const {data = [], loading: dashboardLoading} = useSelector(
    state => state.dashboard,
  );

  const currentYear = dayjs().year();
  const yearOptions = Array.from({length: currentYear - 2019}, (_, i) => ({
    value: (2020 + i).toString(),
    label: (2020 + i).toString(),
  }));

  const handleDateRangeChange = dates => {
    if (dates) {
      setDateRange(dates);
      setSelectedMonth(dates[0].month());
      setSelectedYear(dates[0].year().toString());
    }
  };

  const handleCountYearChange = year => {
    setSelectedYear(year);
    const startDate = dayjs(year).month(selectedMonth).startOf('month');
    const endDate = dayjs(year).month(selectedMonth).endOf('month');
    setDateRange([startDate, endDate]);
  };

  const handleCountMonthChange = month => {
    setSelectedMonth(month);
    const startDate = dayjs()
      .year(parseInt(selectedYear))
      .month(month)
      .startOf('month');
    const endDate = startDate.endOf('month');
    setDateRange([startDate, endDate]);
  };

  const handleGraphYearChange = year => {
    setSelectedGraphYear(year);
  };

  const handleGraphMonthChange = month => {
    setSelectedGraphMonth(month);
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (dateRange && dateRange[0] && dateRange[1]) {
      dispatch(
        fetchDashboardData({
           startDate: dateRange[0].format('YYYY-MM-DD'),
          endDate: dateRange[1].format('YYYY-MM-DD'),
          month: selectedMonth + 1,
          year: selectedYear,
          graph_month: selectedGraphMonth + 1,
          graph_year: selectedGraphYear,
         
        }),
      );
    }
  }, [dateRange, dispatch, selectedMonth, selectedYear, selectedGraphMonth, selectedGraphYear]);

  const warehouseColumns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Pieces',
      dataIndex: 'pieces',
      key: 'pieces',
    },
    {
      title: 'Weight',
      dataIndex: 'weight',
      key: 'weight',
      render: text => (
        <span style={{color: text > 0 ? '#3f8600' : '#cf1322'}}>
          {text > 0 ? '+' : ''}
          {text}%
        </span>
      ),
    },
  ];

  const warehouseData = [
    {
      key: '1',
      type: 'Total Stock',
      quantity: data.packed_bundles?.bundles_created_count || 0,
      pieces: data.packed_bundles?.bundles_created_pieces || 0,
      weight: data.packed_bundles?.bundles_created_weight || 0,
    },
    {
      key: '2',
      type: 'Dispatched to Customer',
      quantity:
        data.dispatched_to_customer?.bundles_dispatched_customer_count || 0,
      pieces:
        data.dispatched_to_customer?.bundles_dispatched_customer_pieces || 0,
      weight:
        data.dispatched_to_customer?.bundles_dispatched_customer_weight || 0,
    },
    {
      key: '3',
      type: 'Dispatched to Warehouse',
      quantity:
        data.dispatched_to_warehouse?.bundles_dispatched_warehouse_count || 0,
      pieces:
        data.dispatched_to_warehouse?.bundles_dispatched_warehouse_pieces || 0,
      weight:
        data.dispatched_to_warehouse?.bundles_dispatched_warehouse_weight || 0,
    },
  ];

  return (
    <div className="dashboard-container">
      <Row gutter={[16, 16]} >
        <Col xs={24} sm={24} md={24}>
          <Card
            title={
              <div className="card-title-wrapper" style={{padding:'15px'}}>
                <div className="title-content">
                  <span className="title-text">Dashboard</span>
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  <CalendarOutlined className='filter-icon' style={{padding:'10px',marginRight:'10px',marginTop:'5px'}}/>
                  <Space size={16} align="center">
                    <RangePicker
                      value={dateRange}
                      format="DD-MM-YYYY"
                      onChange={handleDateRangeChange}
                      style={{width: '300px'}}
                      presets={{
                        Today: [dayjs(), dayjs()],
                        'This Week': [dayjs().startOf('week'), dayjs()],
                        'This Month': [dayjs().startOf('month'), dayjs()],
                        'Last Month': [
                          dayjs().subtract(1, 'month').startOf('month'),
                          dayjs().subtract(1, 'month').endOf('month'),
                        ],
                      }}
                    />
                    <Select
                      value={selectedYear}
                      onChange={handleCountYearChange}
                      options={yearOptions}
                      style={{width: '120px'}}
                      placeholder="Year"
                    />
                  </Space>
                </div>
              </div>
            }
            loading={dashboardLoading}
            className="stats-card"
          >
            <Row gutter={[12, 12]}>
              <Col  xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-primary">
                  <div className="metric-header">
                    <ToolOutlined className="metric-icon" />
                    <span className="metric-title">Total Profiles</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.total_die_count || 0}
                    </span>
                    <div className="metric-stats">
                      <span className="metric-label">Total Profiles</span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-success">
                  <div className="metric-header">
                    <FileDoneOutlined className="metric-icon" />
                    <span className="metric-title">Backup Profiles</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.backup_die_counts || 0}
                    </span>
                    <div className="metric-stats">
                      <span className="metric-label">Total Backup</span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-info">
                  <div className="metric-header">
                    <FileTextOutlined className="metric-icon" />
                    <span className="metric-title">Quotations</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.quotation_count || 0}
                    </span>
                    <div className="metric-stats">
                      <span className="metric-label">Converted</span>
                      <span className="metric-highlight">
                        {data?.quotation_to_workorder_count || 0}
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-warning">
                  <div className="metric-header">
                    <InboxOutlined className="metric-icon" />
                    <span className="metric-title">Work Orders</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.total_workorder_count || 0}
                    </span>
                    <div className="metric-stats">
                      <span className="metric-label">Total Orders</span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-processing2">
                  <div className="metric-header">
                    <InboxOutlined className="metric-icon" />
                    <span className="metric-title">Packed Bundles</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.packed_bundles?.bundles_created_count || 0}
                    </span>
                    {/* <div className="metric-stats">
                      <span className="metric-label">Pieces</span>
                      <span className="metric-highlight">
                        {data?.packed_bundles?.bundles_created_pieces || 0}
                      </span>
                    </div> */}
                    <div className="metric-weight">
                      <span className="weight-label">Weight:</span>
                      <span className="weight-value">
                        {(
                          data?.packed_bundles?.bundles_created_weight || 0
                        ).toFixed(2)}{' '}
                        kg
                      </span>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-success">
                  <div className="metric-header">
                    <FileDoneOutlined className="metric-icon" />
                    <span className="metric-title">Dispatched To Customer</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.dispatched_to_customer
                        ?.bundles_dispatched_customer_count || 0}
                    </span>
                    {/* <div className="metric-stats">
                      <span className="metric-label">Pieces</span>
                      <span className="metric-highlight">
                        {data?.dispatched_to_customer
                          ?.bundles_dispatched_customer_pieces || 0}
                      </span>
                    </div> */}
                    <div className="metric-weight">
                      <span className="weight-label">Weight:</span>
                      <span className="weight-value">
                        {(
                          data?.dispatched_to_customer
                            ?.bundles_dispatched_customer_weight || 0
                        ).toFixed(2)}{' '}
                        kg
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
               <Col xs={12} sm={8} md={6} lg={4} xl={3}>
                <div className="metric-container soft-success2">
                  <div className="metric-header">
                    <FileDoneOutlined className="metric-icon" />
                    <span className="metric-title">Dispatched To Warehouse</span>
                  </div>
                  <div className="metric-content">
                    <span className="metric-value">
                      {data?.dispatched_to_warehouse
                        ?.bundles_dispatched_warehouse_count || 0}
                    </span>
                    {/* <div className="metric-stats">
                      <span className="metric-label">Pieces</span>
                      <span className="metric-highlight">
                        {data?.dispatched_to_customer
                          ?.bundles_dispatched_customer_pieces || 0}
                      </span>
                    </div> */}
                    <div className="metric-weight">
                      <span className="weight-label">Weight:</span>
                      <span className="weight-value">
                        {(
                          data?.dispatched_to_warehouse
                            ?.bundles_dispatched_warehouse_weight || 0
                        ).toFixed(2)}{' '}
                        kg
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
<Row gutter={[16, 16]} style={{marginTop: '24px'}}>
        <Col xs={24}>
          <Card
            title={
              <Row justify="space-between" align="middle">
                <Col >Monthly Stats</Col>
                <Col>
                  <Space>
                    <Select
                      value={selectedGraphYear}
                      onChange={handleGraphYearChange}
                      options={yearOptions}
                      style={{width: 100}}
                      placeholder="Year"
                    />
                    <Select
                      value={selectedGraphMonth}
                      onChange={handleGraphMonthChange}
                      style={{width: 120}}
                      options={Array.from({length: 12}, (_, i) => ({
                        value: i,
                        label: dayjs().month(i).format('MMMM'),
                      }))}
                      placeholder="Month"
                    />
                  </Space>
                </Col>
              </Row>
            }
            loading={dashboardLoading}
            className="graph-card"
            variant="borderless"
          >
            <Graph1 dateRange={dateRange} />
          </Card>
        </Col>
      </Row>

      <style jsx="true">{`
        .dashboard-container {
          background: #fafafa;
          min-height: calc(100vh - 64px);
          padding: 12px;
        }
        .filter-card {
          background: white;
          border-radius: 20px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
          margin-bottom: 32px;
          border: 1px solid #edf2f7;
        }
        .filter-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 32px;
        }
        .filter-controls {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .filter-title {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .filter-icon {
          font-size: 24px;
          color: #4299e1;
          padding: 16px;
          background: #ebf8ff;
          border-radius: 16px;
          transition: all 0.3s ease;
        }
        .filter-icon:hover {
          background: #bee3f8;
          transform: translateY(-2px);
        }
        .title-text h3 {
          margin: 0;
          font-size: 20px;
          font-weight: 600;
          color: #2d3748;
          letter-spacing: -0.5px;
        }
        .title-text p {
          margin: 4px 0 0;
          font-size: 14px;
          color: #718096;
        }

        /* Card Styles */
        .stat-card {
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .stat-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.05);
        }

        /* Icon Wrappers */
        .icon-wrapper {
          width: 56px;
          height: 56px;
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        .icon-wrapper.success {
          background: #f0fff4;
          border: 1px solid #c6f6d5;
        }
        .icon-wrapper.info {
          background: #ebf8ff;
          border: 1px solid #bee3f8;
        }
        .icon-wrapper.warning {
          background: #fffaf0;
          border: 1px solid #feebc8;
        }
        .icon-wrapper.processing {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }

        /* Icons */
        .stat-icon {
          font-size: 28px;
          transition: all 0.3s ease;
        }
        .icon-wrapper.success .stat-icon {
          color: #48bb78;
        }
        .icon-wrapper.info .stat-icon {
          color: #4299e1;
        }
        .icon-wrapper.warning .stat-icon {
          color: #ecc94b;
        }
        .icon-wrapper.processing .stat-icon {
          color: #38b2ac;
        }

        /* Statistics */
        .stat-content {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }
        .stat-numbers {
          display: flex;
          align-items: center;
          gap: 28px;
          padding: 16px 0;
        }
        .primary-stat,
        .secondary-stat {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }
        .primary-stat .value {
          font-size: 36px;
          font-weight: 600;
          color: #2d3748;
          line-height: 1;
          letter-spacing: -0.5px;
        }
        .secondary-stat .value {
          font-size: 28px;
          font-weight: 500;
          color: #4a5568;
          line-height: 1;
        }
        .primary-stat .label,
        .secondary-stat .label {
          font-size: 14px;
          color: #718096;
          font-weight: 500;
        }
        .divider {
          width: 1px;
          height: 48px;
          background: #edf2f7;
        }

        /* Progress Bars */
        .progress-info {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 4px;
        }
        .progress-info .percent {
          font-size: 18px;
          font-weight: 600;
          color: #2d3748;
        }
        .progress-info .label {
          font-size: 13px;
          color: #718096;
          font-weight: 500;
        }

        /* Metrics */
        .metric-container {
          padding: 12px;
          border-radius: 12px;
          height: 100%;
          transition: all 0.3s ease;
          min-height: 140px;
        }
        .metric-container:hover {
          background: #edf2f7;
          transform: translateY(-2px);
        }
        .metric-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 12px;
        }
        .metric-icon {
          font-size: 16px;
        }
        .metric-icon.primary {
          color: #4299e1;
        }
        .metric-icon.info {
          color: #38b2ac;
        }
        .metric-icon.warning {
          color: #ecc94b;
        }
        .metric-icon.success {
          color: #48bb78;
        }
        .metric-icon.processing {
          color: #38b2ac;
        }

        .metric-title {
          font-size: 13px;
          font-weight: 500;
          color: #4a5568;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .metric-value {
          font-size: 24px;
          font-weight: 600;
          color: #2d3748;
          line-height: 1;
        }
        .metric-suffix {
          font-size: 14px;
          color: #718096;
          font-weight: 500;
        }

        /* Graph Card */
        .graph-card {
          background: #ffffff;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        }
        .card-title-wrapper {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .card-title-icon {
          font-size: 24px;
          color: #4299e1;
        }

        /* Progress Section */
        .delivery-progress {
          padding: 20px;
          background: #f7fafc;
          border-radius: 16px;
          margin-top: 16px;
          border: 1px solid #edf2f7;
        }
        .progress-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }
        .progress-title {
          font-size: 15px;
          color: #4a5568;
          font-weight: 500;
        }
        .progress-stats {
          font-size: 14px;
          color: #718096;
          font-weight: 500;
        }

        /* Form Controls */
        :global(.ant-picker) {
          border-radius: 8px;
          height: 40px;
          border-color: #e2e8f0;
        }
        :global(.ant-select-selector) {
          border-radius: 8px !important;
          height: 40px !important;
          border-color: #e2e8f0 !important;
        }
        :global(.ant-select-selection-item) {
          line-height: 38px !important;
        }
        :global(.ant-picker:hover),
        :global(.ant-picker-focused),
        :global(
            .ant-select:not(.ant-select-disabled):hover .ant-select-selector
          ) {
          border-color: #4299e1 !important;
          box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.1) !important;
        }
        :global(.ant-space) {
          display: flex;
          align-items: center;
        }

        /* Card Title Styles */
        .card-title-wrapper {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        .title-icon-wrapper {
          width: 40px;
          height: 40px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }
        .title-icon-wrapper.primary {
          background: #ebf8ff;
          border: 1px solid #bee3f8;
        }
        .title-icon-wrapper.processing {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }
        .title-icon {
          font-size: 20px;
          color: #4299e1;
        }
        .title-icon-wrapper.processing .title-icon {
          color: #38b2ac;
        }
        .title-content {
          display: flex;
          flex-direction: column;
          gap: 2px;
        }
        .title-text {
          font-size: 16px;
          font-weight: 600;
          color: #2d3748;
        }
        .title-description {
          font-size: 13px;
          color: #718096;
        }

        /* Metric Container Styles */
        .metric-container {
          padding: 12px;
          border-radius: 12px;
          height: 100%;
          transition: all 0.3s ease;
          min-height: 140px;
        }
        .metric-container.primary {
          background: #ebf8ff;
          border: 1px solid #bee3f8;
        }
        .metric-container.info {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }
        .metric-container.warning {
          background: #fffaf0;
          border: 1px solid #feebc8;
        }
        .metric-container.success {
          background: #f0fff4;
          border: 1px solid #c6f6d5;
        }
        .metric-container.processing {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }
          
        .metric-container:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
        }

        /* Metric Content Styles */
        .metric-header {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 12px;
        }
        .metric-icon {
          font-size: 16px;
        }
        .metric-container.primary .metric-icon {
          color: #4299e1;
        }
        .metric-container.info .metric-icon {
          color: #38b2ac;
        }
        .metric-container.warning .metric-icon {
          color: #ecc94b;
        }
        .metric-container.success .metric-icon {
          color: #48bb78;
        }
        .metric-container.processing .metric-icon {
          color: #38b2ac;
        }

        .metric-title {
          font-size: 13px;
          font-weight: 500;
          color: #4a5568;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .metric-content {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        .metric-value {
          font-size: 24px;
          font-weight: 600;
          color: #2d3748;
          line-height: 1;
        }
        .metric-stats {
          margin-top: 6px;
          padding-top: 6px;
          border-top: 1px dashed #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .metric-label {
          font-size: 12px;
          color: #718096;
        }
        .metric-highlight {
          font-size: 12px;
          font-weight: 600;
          color: #2d3748;
        }

        /* Progress Section Styles */
        .delivery-progress {
          padding: 20px;
          background: #f7fafc;
          border-radius: 16px;
          border: 1px solid #edf2f7;
        }
        .progress-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 16px;
        }
        .progress-info {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .progress-title {
          font-size: 14px;
          color: #2d3748;
          font-weight: 600;
        }
        .progress-subtitle {
          font-size: 13px;
          color: #718096;
        }
        .progress-stats {
          display: flex;
          align-items: baseline;
          gap: 4px;
          font-size: 14px;
        }
        .stats-current {
          color: #38b2ac;
          font-weight: 600;
        }
        .stats-separator {
          color: #cbd5e0;
          margin: 0 2px;
        }
        .stats-total {
          color: #4a5568;
          font-weight: 500;
        }
        .stats-unit {
          color: #718096;
          font-size: 13px;
          margin-left: 2px;
        }

        .title-icon-wrapper.warning {
          background: #fffaf0;
          border: 1px solid #feebc8;
        }
        .title-icon-wrapper.success {
          background: #f0fff4;
          border: 1px solid #c6f6d5;
        }
        .title-icon-wrapper.info {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }
        .title-icon-wrapper.warning .title-icon {
          color: #ecc94b;
        }
        .title-icon-wrapper.success .title-icon {
          color: #48bb78;
        }
        .title-icon-wrapper.info .title-icon {
          color: #38b2ac;
        }

        .metric-numbers {
          display: flex;
          align-items: center;
          gap: 24px;
          padding: 20px 0;
          margin-bottom: 20px;
          border-bottom: 1px dashed #e2e8f0;
        }

        .metric-progress {
          padding-top: 4px;
        }

        .progress-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 12px;
        }

        .progress-title {
          font-size: 14px;
          color: #4a5568;
          font-weight: 500;
        }

        .progress-stats {
          display: flex;
          align-items: baseline;
          gap: 4px;
        }

        .stats-current {
          font-size: 16px;
          font-weight: 600;
        }

        .metric-container.primary .stats-current {
          color: #4299e1;
        }
        .metric-container.info .stats-current {
          color: #38b2ac;
        }
        .metric-container.warning .stats-current {
          color: #ecc94b;
        }
        .metric-container.success .stats-current {
          color: #48bb78;
        }

        .stats-unit {
          font-size: 13px;
          color: #718096;
          margin-left: 2px;
        }

        .metric-container.primary {
          background: #ebf8ff;
          border: 1px solid #bee3f8;
        }
        .metric-container.info {
          background: #e6fffa;
          border: 1px solid #b2f5ea;
        }
        .metric-container.warning {
          background: #fffaf0;
          border: 1px solid #feebc8;
        }
        .metric-container.success {
          background: #f0fff4;
          border: 1px solid #c6f6d5;
        }

        .metric-container.soft-primary {
          background: #f0f7ff;
          border: 1px solid #bfdbfe;
        }
        .metric-container.soft-success {
          background:rgba(232, 236, 194, 0.2);
          border: 1px solid #bbf7d0;
        }

         .metric-container.soft-success2 {
          background:rgba(138, 229, 205, 0.2);
          border: 1px solid #bbf7d0;
        }
        .metric-container.soft-info {
          background: #f0fdfa;
          border: 1px solid #99f6e4;
        }
           .metric-container.soft-info2 {
          background:rgba(172, 235, 143, 0.2);
          border: 1px solid rgba(236, 175, 231, 0.2);
        }


        .metric-container.soft-warning {
          background: #fefce8;
          border: 1px solid #fef08a;
        }
                  .metric-container.soft-warning2 {
          background:rgba(229, 214, 239, 0.16);
          border: 1px solid rgba(214, 180, 236, 0.16);
        }
        .metric-container.soft-processing {
          background: #eff6ff;
          border: 1px solid #bfdbfe;
        }
          .metric-container.soft-processing2 {
          background:rgba(241, 168, 183, 0.15);
          border: 1px solid rgba(241, 168, 183, 0.15);
        }

        .metric-container.soft-primary .metric-icon {
          color: #4299e1;
        }
        .metric-container.soft-success .metric-icon {
          color: #48bb78;
        }
        .metric-container.soft-info .metric-icon {
          color: #38b2ac;
        }
        .metric-container.soft-warning .metric-icon {
          color: #ecc94b;
        }
        .metric-container.soft-processing .metric-icon {
          color: #3182ce;
        }

        .metric-weight {
          margin-top: 6px;
          padding-top: 6px;
          border-top: 1px dashed #e2e8f0;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .weight-label {
          font-size: 11px;
          color: #718096;
        }

        .weight-value {
          font-size: 12px;
          color: #2d3748;
          font-weight: 600;
        }

        .metric-highlight {
          font-size: 12px;
          font-weight: 600;
          color: #2d3748;
          margin-left: 8px;
        }

        .metric-stats {
           margin-top: 6px;
          padding-top: 6px;
         
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .metric-label {
          font-size: 12px;
          color: #718096;
        }
      `}</style>
    </div>
  );
}
